var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiaogao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631287",
    x: 2.625,
    y: 1.3125,
    width: 4.6875,
    height: 13.6875,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 30",
    x1: 10.375,
    y1: 1.375,
    x2: 15.3125,
    y2: 1.375,
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 32",
    x1: 12.9688,
    y1: 1.42188,
    x2: 12.9687,
    y2: 14.8906,
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 31",
    x1: 10.375,
    y1: 15,
    x2: 15.3125,
    y2: 15,
    stroke: "#626262"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiaogao);
export default __webpack_public_path__ + "static/media/biaogao.db8e93d9bfa7877dffd6b8e7066d1368.svg";
export { ForwardRef as ReactComponent };